import React, { Component } from 'react';
import { toast } from 'react-toastify';

import withAuthorization from '../../Session/withAuthorization';
import { db, auth } from '../../../firebase';
import { Form, Button, Input, FormGroup, Label} from 'reactstrap';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import Spinner from "../../Spinner";
import * as common from '../../../constants/common';


const CreateComplainPage = ({ sessionStore }) =>
        <CreateComplainForm authUser = {sessionStore.authUser} />

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  complainText: '',
  subject: '',
  canImpersonate:false,
  userId:'',
  users: {},
  isLoading:true
};

class CreateComplainForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }
  
  componentDidMount(){
    auth.getCurrentUserToken()
    .then(token => {
      if(token.claims.isAdmin || token.claims.isModerator){
        // refactor, move to function
        db.onceGetUsersToImpersonate(this.props.authUser.uid)
        .then(users =>{
          let usersValue = users.val();
          if(token.claims.isAdmin){
            delete usersValue[this.props.authUser.uid];
          }
          return this.setState({
            canImpersonate:true,
            users: usersValue,
            userId: Object.keys(users.val())[0],
            isLoading:false 
          });
        })
        .catch(error => {
          toast.error(common.ERROR_MESSAGE, {
              toastId:"Error message",
              position: toast.POSITION.BOTTOM_RIGHT                  
          });

          return this.setState(() => ({ 
              isLoading:false
          }));
        });   
      }
      else{
        this.setState({
          isLoading:false
        })
      }
    })
    .catch(error => {
      toast.error(common.ERROR_MESSAGE, {
        toastId:"Error message",
        position: toast.POSITION.BOTTOM_RIGHT                  
      });

      return this.setState(() => ({ 
        isLoading:false
      }));
    })
  }

  onSubmit = (event) => {

    let userId;

    this.setState({
      isLoading:true
    });

    if(this.state.canImpersonate){
      userId = this.state.userId;
    }
    else{
      userId = this.props.authUser.uid;
    }

    db.doCreateComplain(userId, this.state.subject, this.state.complainText)
      .then(() => {
        // refactor
        toast.success("Incidentas sukurtas",{
          position: toast.POSITION.BOTTOM_RIGHT
        });
        this.setState({
          subject:'',
          complainText:'',
          isLoading:false
        });
      })
      .catch(error => {
        toast.error(common.ERROR_MESSAGE, {
          toastId:"Error message",
          position: toast.POSITION.BOTTOM_RIGHT                  
        });
        this.setState({
          isLoading:false
        });
      });

    event.preventDefault();
  }

  render() {

    const {
      subject,
      complainText,
      users,
      isLoading
    } = this.state;
    
    const isInvalid = (complainText === '' || subject === '');

    if(isLoading){
      return(    
        <Spinner></Spinner>
    )
    }
    else{

    return (
      <Form onSubmit={this.onSubmit}>
      <FormGroup>
        <Label>Subjektas:</Label>
        <Input 
          value={subject}
          onChange={event => this.setState(updateByPropertyName('subject', event.target.value))}
          type="text"
          placeholder="Būtinas laukas"/>
        </FormGroup>

        <FormGroup>
          <Label>Aprašymas:</Label>
          <Input
            value={complainText}
            onChange={event => this.setState(updateByPropertyName('complainText', event.target.value))}
            type="textarea"
            placeholder="Būtinas laukas"
          />
        </FormGroup>
        {this.state.canImpersonate ?    
          <FormGroup>
            <Label for="exampleSelect">Pasirinkti vartotoją:</Label>
            <Input 
              type="select"
              name="select"
              id="exampleSelect"
              onChange={event => this.setState(updateByPropertyName("userId",event.target.value))}>
              
              {Object.keys(users).map(key =>{
                return <option key={key} value={key}>{users[key].alias}</option>
              })}

            </Input>
          </FormGroup> : (null)}

      <FormGroup>
        <Button disabled={isInvalid} type="submit">
        Užsaugoti incidentą
        </Button>
      </FormGroup>
      </Form>
    );
  }
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('sessionStore'),
  observer
)(CreateComplainPage);


// WEBPACK FOOTER //
// ./src/components/Complains/CreateComplain/index.js